import '../css/app.css'
import Alpine from 'alpinejs'
import baguetteBox from 'baguettebox.js'
import { Splide } from '@splidejs/splide'
import './cookie3.js'

document.documentElement.classList.add('js-enabled')

// ALPINE
window.Alpine = Alpine
Alpine.start()

window.addEventListener('load', function () {
  baguetteBox.run('.baguette', {
    noScrollbars: true,
  })

  const galleries = document.getElementsByClassName('splide-gallery')
  for (let i = 0, len = galleries.length; i < len; i++) {
    new Splide(galleries[i], {
      type: 'loop',
      lazyLoad: 'nearby',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: true,
      autoplay: false,
      arrowPath:
        'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z',
    }).mount()
  }
})
